import type { ReactNode } from 'react'
import { ArchiveBoxIcon, ClockIcon, CommandLineIcon, CreditCardIcon, DocumentTextIcon, FingerPrintIcon, FolderIcon, KeyIcon, MapPinIcon } from '@heroicons/react/24/outline'
import './firstUse.css'

export type CompactEmptyKind = 'vault' | 'invoice' | 'payment' | 'address' | 'token' | 'ssh' | 'activity'

const icons: Record<CompactEmptyKind, ReactNode> = {
  vault: <><ArchiveBoxIcon /><span className="compact-empty-world" /></>,
  invoice: <><FolderIcon /><DocumentTextIcon /></>,
  payment: <><CreditCardIcon /><span className="compact-empty-slot" /></>,
  address: <><MapPinIcon /><span className="compact-empty-lines" /></>,
  token: <><CommandLineIcon /><KeyIcon /></>,
  ssh: <><FolderIcon /><FingerPrintIcon /></>,
  activity: <><ClockIcon /><span className="compact-empty-trail" /></>,
}

export default function CompactEmptyExperience({ kind, title, description, action, label }: { kind: CompactEmptyKind; title: string; description: string; action?: ReactNode; label?: string }) {
  return (
    <section className={`compact-empty-experience compact-empty-experience--${kind}`}>
      <div className="compact-empty-art" aria-hidden="true">{icons[kind]}</div>
      <div className="compact-empty-copy">
        {label && <p className="first-use-eyebrow">{label}</p>}
        <h3>{title}</h3>
        <p>{description}</p>
        {action && <div className="compact-empty-action">{action}</div>}
      </div>
    </section>
  )
}
